<template>
  <div class="error-card">
    <h1 class="text-h3">{{ error }}</h1>
  </div>
</template>

<script>
export default {
  name: "ErrorCard",
  props: {
    error: {
      type: String,
      default: "404: Page Not Found"
    }
  }
};
</script>
<style scoped>
.error-card {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
